var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3655 14.1L16.0155 8.45C16.1488 8.31667 16.3044 8.25 16.4822 8.25C16.6599 8.25 16.8155 8.31667 16.9488 8.45C17.0822 8.58333 17.1488 8.74178 17.1488 8.92533C17.1488 9.10889 17.0822 9.26711 16.9488 9.4L10.8322 15.5333C10.6988 15.6667 10.5433 15.7333 10.3655 15.7333C10.1877 15.7333 10.0322 15.6667 9.89882 15.5333L7.03215 12.6667C6.89882 12.5333 6.83482 12.3751 6.84015 12.192C6.84548 12.0089 6.91504 11.8504 7.04882 11.7167C7.1826 11.5829 7.34104 11.5162 7.52415 11.5167C7.70726 11.5171 7.86548 11.5838 7.99882 11.7167L10.3655 14.1Z",
    fill: "#0D9813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowComplete);
export default __webpack_public_path__ + "static/media/circle-arrow-complete.6c596cb9ff52d4c402f23d1a7ef23517.svg";
export { ForwardRef as ReactComponent };